import { render } from "./formfile.vue?vue&type=template&id=226a9772&scoped=true"
import script from "./formfile.vue?vue&type=script&lang=js"
export * from "./formfile.vue?vue&type=script&lang=js"

import "./formfile.vue?vue&type=style&index=0&id=226a9772&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-226a9772"]])

export default __exports__